/**
 * Cihaz parçaları (component key) → Türkçe etiket + görsel haritası.
 * Görseller BeverageMachine/src/asset/icon'dan src/assets/parts'a kopyalandı.
 * Server component key'lerini normalize ediyor (mainsWaterPump →
 * waterTankMainsWaterPump) ama legacy alias'ları da burada tutuyoruz.
 */

import grinder from "../Assets/parts/grinder3.png";
import mainsPump from "../Assets/parts/mainsWaterPump.webp";
import carboyPump from "../Assets/parts/carboyWaterPump.webp";
import pumpRelay from "../Assets/parts/waterPumpRelay.webp";
import heaterRelay from "../Assets/parts/waterTankHeaterRelay.webp";
import tempSensor from "../Assets/parts/waterTankTemperatureSensor.webp";
import levelSensor from "../Assets/parts/waterTankLevelSensor.webp";
import valve from "../Assets/parts/valve.webp";
import potWaterPump from "../Assets/parts/water-tank-128-blue.png";
import screen from "../Assets/parts/screen.webp";

export const PART_META = {
  grinder: { label: "Değirmen", img: grinder },
  waterTankMainsWaterPump: { label: "Şebeke Pompası", img: mainsPump },
  waterTankCarboyWaterPump: { label: "Damacana Pompası", img: carboyPump },
  // legacy alias'lar (server normalize etse de güvence)
  mainsWaterPump: { label: "Şebeke Pompası", img: mainsPump },
  carboyWaterPump: { label: "Damacana Pompası", img: carboyPump },
  waterPumpRelay: { label: "Su Pompası Rölesi", img: pumpRelay },
  waterTankHeaterRelay: { label: "Kazan Isıtıcı Rölesi", img: heaterRelay },
  waterTankTemperatureSensor: { label: "Kazan Sıcaklık Sensörü", img: tempSensor },
  waterTankLevelSensor: { label: "Kazan Seviye Sensörü", img: levelSensor },
  waterValve: { label: "Su Valfi", img: valve },
  brewValve: { label: "Demleme Valfi", img: valve },
  potWaterPump: { label: "Göz Su Pompası", img: potWaterPump },
  screen: { label: "Ekran", img: screen },
};

export function getPartMeta(key) {
  return PART_META[key] || { label: key || "Bilinmeyen Parça", img: null };
}
